import React from "react";
import { Link } from "react-router-dom";
import { setProgress } from "../../../slices/loadingBarSlice";
import { useDispatch } from "react-redux";

/**
 * StudyNotion-style CTAs — yellow primary, outline on rich black.
 * @param {boolean} active — primary (yellow) vs outline
 * @param {"light" | "dark"} surface — outline on dark hero vs light card
 */
const Button = ({ children, active, linkto, surface = "light" }) => {
  const dispatch = useDispatch();
  const primary =
    "rounded-[8px] bg-yellow-50 px-[12px] py-[8px] text-center text-[13px] font-semibold text-richblack-900 shadow-sm transition-all duration-200 hover:scale-95 hover:bg-yellow-100";
  const outlineLight =
    "rounded-[8px] border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-center text-[13px] font-semibold text-richblack-5 transition-all duration-200 hover:bg-richblack-700 hover:text-richblack-5";
  const outlineDark =
    "rounded-[8px] border border-richblack-600 bg-richblack-800 px-[12px] py-[8px] text-center text-[13px] font-semibold text-richblack-5 transition-all duration-200 hover:bg-richblack-700";

  const cls = active ? primary : surface === "dark" ? outlineDark : outlineLight;

  return (
    <Link
      onClick={() => {
        dispatch(setProgress(100));
      }}
      to={linkto}
    >
      <div className={cls}>{children}</div>
    </Link>
  );
};

export default Button;
